// Remove 'www' from the cookie domain to ensure it remains accessible throughout checkout
export const modifyAlgoliaCookieDomain = async () => {
  const algoliaCookie = await window.cookieStore.get('_ALGOLIA');
  const domain = window.location.hostname.replace('www.', '');
  await window.cookieStore.set({ ...algoliaCookie, domain });
  return window.cookieStore.delete(algoliaCookie);
};
